import Table from "@/components/AdvanceTable"
import {getUserList,userAdd,userUpdate,userDelete} from "@/api/user.js"
import {getAll} from "@/api/company"
import {getSearchParm} from "@/utils/index.js"
import { columns,requires,saveinputs } from "./data"
import {getAll as getworkplacereq} from "@/api/workplace.js"

let user = JSON.parse(sessionStorage.getItem("userinfo"))
export default {
    data(){
        return {
            columns,
            request:{
                "get":(parm)=>{
					if(user.cmpid == -1){
						return getUserList(parm)
					}else{
						return getUserList({...parm,"cmpid":user.cmpid})
					}
				} ,
                "add":userAdd,
                "update":userUpdate,
                "delet":userDelete
            },
            searchData:getSearchParm({
				username:"",
			    cmpid:"",
				wxname:"",
				idcard:"",
				phonenum:""
			}),
		    user,
			cmps:[],
			saveinputs,
            formData:{
            },
        }
    },
    components:{
        Table,
    },
    mounted(){
		getAll().then(ret=>{
			if(ret.code == 0){
				let list = ret.ret
				if(this.user.cmpid == -1){
					this.cmps = list
				}else{
					let cmp = list.find(item=>{
					return item.id == this.user.cmpid
				})
				if(cmp){
					this.cmps = [cmp]
				}
			}
			}
		})
		this.getworkpalceArrary()
		
    },
    methods:{
        updateuser(record,showModal){
            this.formData = {...record}
            showModal("修改用户信息",requires)
        },
        addUser(showModal){
            this.formData = {cmpid:this.user.cmpid}
            showModal("添加用户信息",requires)
        },
        deleteUser(record,showDelConfirm){
            this.formData = {...record}
            showDelConfirm()
        },
		getcmpname(id){
			let tmp = this.cmps.find(item=>item.id==id)
			if(tmp){
				return tmp.name
			}else{
				return ""
			}
		},
		
	}
}

